export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";